<span class="color-component" [style.background-color]="color">&nbsp;</span>